var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header"
  }, [_vm.imageUrl ? _c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": _vm.imageUrl,
      "alt": "Header Logo"
    }
  })]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }